<template>

  <el-dialog class="modal-95-70-60" :title="addForm.id ? 'Редактировать шаблон' : 'Добавить шаблоны'"
             v-model="addFormVisible" @close="$emit('close')">
    <el-form label-position="top" :model="addForm">
      <slot name="admin-add-form-components"/>
      <span @click="rulesListVisible = !rulesListVisible"
            style="color: var(--el-color-primary); cursor: pointer;">Основные правила составления шаблонов&nbsp;<font-awesome-icon
          icon="chevron-down"/><br/><br/></span>
      <div v-show="rulesListVisible">
        <p class="wra">
          Текст шаблона сообщения может состоять либо исключительно из статичной части (например, <i>"Ваш заказ
          доставлен."</i> ), либо из статичной и изменяемой частей (например, <i>"Ваш заказ будет доставлен <b>01.01.2023
          16:00</b>"</i> ).<br/>
          Изменяемую часть в шаблоне необходимо заменять следующими операндами:
        </p>
        <p><b>%w</b> - любой непрерывный (без пробелов) набор букв, цифр и спецсимволов;</p>
        <p><b>%d</b> - любой непрерывный (без пробелов) набор цифр и спецсимволы;</p>
        <p><b>%w{1,n}</b> - Ограниченная последовательность слов (состоящих из букв, цифр или спецсимволов), разделенных
          пробелом, где n - целое число, которое не может принимать значение 1 и должно быть в диапазоне от 2 до 15 (2
          &lt;= n &lt;= 15);</p>
        <p><b>%d{1,n}</b> - Ограниченная последовательность чисел (состоящих из цифр или спецсимволов), разделенных
          пробелом, где n - целое число, которое не может принимать значение 1 и должно быть в диапазоне от 2 до 20 (2
          &lt;= n &lt;=20).</p>
        <br/>
        <br/>
        <p><u>При составлении шаблонов необходимо придерживаться определенных правил:</u></p><br/>
        <p>- операнды должны обязательно отделяться от слов пробелами с обеих сторон;</p>
        <p>- две и более операнды не могут находиться рядом друг с другом (например, конструкция <i>"Ваш заказ <b>%d</b>
          <b>%w</b>"</i> должна быть заменена на <i>"Ваш заказ <b>%w{1,2}</b>"</i>);</p>
        <p>- шаблон должен без затруднений идентифицироваться с текстом конечного сообщения.</p>
        <p>- В тексте сообщения (включая системные переменные %d, %d{1,n}, %w, %w{1,n}) допускается использование ТОЛЬКО следующего перечня символов: <b>! № # % . , : ; ? \ / ( ) + - “ ” _ ' " ` ^ { } [ ] &lt; &gt; | @ $ = ~ *</b> Использование любых других символов запрещено.</p>
        <el-divider/>
      </div>

      <el-form-item label="Группа операторов" class="is-required">
        <el-select v-model="addForm.operatorGroup" :disabled="!!addForm.id">
          <el-option v-for="o in operatorsOptions" :value="o.id" :label="o.name"/>
        </el-select>

      </el-form-item>
      <p class="text-red" v-show="isMts" style="margin-bottom: 15px; margin-top: 0px">
        <b>Абонентская плата по оператору МТС за каждый шаблон составит 1 020 руб. в месяц.</b>
      </p>
      <p class="text-red" v-show="isT2" style="margin-bottom: 15px; margin-top: 0px">
        <b>Абонентская плата по оператору T2 за каждый шаблон составит 1 100 руб. в месяц.</b>
      </p>
      <p class="text-red" v-show="isBeeline" style="margin-bottom: 15px; margin-top: 0px">
        <b>Абонентская плата по оператору Билайн за первые два шаблона - 0 руб., начиная с третьего - 1 220 руб. в месяц.</b>
      </p>
      <p class="text-red" v-show="isMegafon" style="margin-bottom: 15px; margin-top: 0px">
        <b>Абонентская плата по оператору Мегафон за каждый шаблон составит 1 220 руб. в месяц.</b>
      </p>
      <el-form-item label="Когда активировать" v-show="isMts">
        <el-select v-model="addForm.activationDateRequested">
          <el-option value="now" label="Как можно скорее"/>
          <el-option value="nextMonth" label="С 1го числа следующего месяца"/>
        </el-select>

      </el-form-item>
      <el-form-item label="Тип трафика" class="is-required">
        <el-select v-model="addForm.trafficType" :disabled="!addForm.operatorGroup">
          <el-option v-for="o in trafficTypeOptions" :value="o.value" :label="o.name"
                     :disabled="!o.availableOperators.includes(addForm.operatorGroup)"/>
        </el-select>
      </el-form-item>
      <el-form-item label="Подпись" class="is-required">
        <el-select v-model="addForm.sender" filterable :disabled="!addForm.operatorGroup">
          <el-option v-for="s in senderOptions" :value="s" :label="s" :disabled="!senderRegisteredOnOperator(s)"/>
        </el-select>
      </el-form-item>

      <el-form-item v-if="!isMts" label="Шаблон (добавьте несколько разделяя одним или более символом новой строки)" class="is-required">
        <el-input type="textarea" :rows="5" v-model="addForm.texts"/>
      </el-form-item>
      <div v-if="isMts" style="text-align: right">
        <el-button type="primary" size="small" @click="addEmptyTemplate" v-if="!addForm.id">+ шаблон</el-button>
        <el-row :gutter="20" v-for="(tsp, k) in addForm.textSamplePairs || []">
          <el-col :span="11">
            <el-form-item label="Шаблон" class="is-required">
              <el-input type="textarea" :rows="2" v-model="addForm.textSamplePairs[k].text"/>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="Пример сообщения" class="is-required">
              <el-input type="textarea" :rows="2" v-model="addForm.textSamplePairs[k].sampleMessage"/>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item label=" "  v-if="!addForm.id">
              <button @click="removeTextSamplePair(tsp.id)" type="button">
                <font-awesome-icon icon="times" />
              </button>
            </el-form-item>
          </el-col>
          <el-divider />
        </el-row>

      </div>
      <p class="text-red" v-show="!canSave" style="margin-bottom: 15px; margin-top: 0px">
        <b>Убедитесь, что все поля заполнены и текст шаблона соответствует правилам.</b>
      </p>
      <p class="text-red" v-show="!textAndSampleNotEqual" style="margin-bottom: 15px; margin-top: 0px">
        <b>Пожалуйста, укажите реальный пример текста сообщения.</b>
      </p>
      <el-button type="success" @click="$emit('onSave', addForm)" :loading="saving"
                 :disabled="!canSave">
        {{ addForm.id ? 'Сохранить' : 'Добавить' }}
      </el-button>
    </el-form>
  </el-dialog>


</template>

<script>


class TemplSamplePair {
  id = ""
  text = ""
  sampleMessage = ""
}

class NewTemplateForm {
  id = ""
  userId = ""
  operatorGroup = ""
  trafficType = "service"
  sender = ""
  status = "active"
  texts = ""
  textSamplePairs = []
  activationDateRequested = "now"
}

const hasOnlyValidSymbols = text => {
  return /^[a-zа-яёЁ0-9!№#%.,:;?\\/()+\-“”_'"`^{}\[\]<>|@$=~*\s]+$/gi.test(text)
}

export default {
  name: "AddEditServiceTemplateModal",
  props: ["allowedSendersPerOperator", "visible", "saving", "senderOptions"],
  components: {},
  watch: {
    visible(v) {
      this.addFormVisible = v
    },
    "addForm.operatorGroup": async function (newV) {
      this.addForm.trafficType = ""
      this.addForm.sender = ""
      await this.$nextTick()
      if (this.isMts && !this.addForm.textSamplePairs.length)
        this.addEmptyTemplate()
      this.$emit("operatorChange", newV)
    }
  },

  methods: {
    trafficType(row) {
      return TRAFFIC_TYPES[row.traffic_type] || "Не определен"
    },
    reset() {
      this.addForm = new NewTemplateForm()
    },
    async setEditTemplate(r) {
      this.addForm.id = r.id
      this.addForm.operatorGroup = r.opg_id
      await this.$nextTick()
      if (this.isMts) {
        this.addForm.textSamplePairs.push({
          text: r.template,
          sampleMessage: r.sampleMessage || ""
        })
      } else {
        this.addForm.texts = r.template
      }
      this.addForm.trafficType = r.traffic_type
      this.addForm.sender = r.sender_name

      this.addForm.activationDateRequested = r.activationDateRequested || "now"

    },
    senderRegisteredOnOperator(name) {
      if (!this.allowedSendersPerOperator) return true
      return this.allowedSendersPerOperator[this.addForm.operatorGroup] && this.allowedSendersPerOperator[this.addForm.operatorGroup].includes(name)
    },
    addEmptyTemplate() {
      let _t = new TemplSamplePair()
      _t.id = Math.random().toString(36)
      this.addForm.textSamplePairs.push(_t)
    },
    removeTextSamplePair(id) {
      let index = this.addForm.textSamplePairs.findIndex(t => t.id === id)
      if (index > -1) this.addForm.textSamplePairs.splice(index, 1)
    }
  },
  computed: {
    isMts() {
      return this.addForm.operatorGroup === '570e2c11b52438c11a38f99c'
    },
    isT2() {
      return this.addForm.operatorGroup === '570e2cb6b52438c11a38f99e'
    },
    isBeeline() {
      return this.addForm.operatorGroup === '570e2c6cb52438c11a38f99d'
    },
    isMegafon() {
      return this.addForm.operatorGroup === '570e2be8b52438c11a38f99b'
    },
    textAndSampleNotEqual(){
      if(this.isMts){
        return this.addForm.textSamplePairs.every(p =>
            (p.text || "").trim() !== (p.sampleMessage).trim()
        )
      }else return true
    },
    canSave(){
      if(!(this.addForm.sender && this.addForm.trafficType && this.addForm.operatorGroup)) return false
      if(this.isMts){
        return this.addForm.textSamplePairs.every(p =>
            !!(p.text || "").trim() &&
            !!(p.sampleMessage).trim() &&
            this.textAndSampleNotEqual &&
            hasOnlyValidSymbols(p.text)
        )
      }else{
        return !!(this.addForm.texts || "").trim() && hasOnlyValidSymbols(this.addForm.texts)
      }
    }
  },
  data() {
    return {

      addFormVisible: false,
      addForm: new NewTemplateForm(),

      operatorsOptions: [
        {id: "570e2be8b52438c11a38f99b", name: "РФ_МегаФон"},
        {id: "570e2c11b52438c11a38f99c", name: "РФ_МТС"},
        {id: "570e2c6cb52438c11a38f99d", name: "РФ_Билайн"},
        {id: "570e2cb6b52438c11a38f99e", name: "РФ_Теле2"},
        {id: "570e2f37b52438c11a38f9a0", name: "РФ_МОТИВ"}
      ],
      trafficTypeOptions: [
        {
          value: "service",
          name: "Сервисный",
          availableOperators: ['570e2c11b52438c11a38f99c', '570e2c6cb52438c11a38f99d', '570e2cb6b52438c11a38f99e', '570e2f37b52438c11a38f9a0']
        },
        {
          value: "authorisation",
          name: "Авторизационный",
          availableOperators: ['570e2be8b52438c11a38f99b', '570e2cb6b52438c11a38f99e']
        },
        {value: "informational", name: "Информационный", availableOperators: ['570e2be8b52438c11a38f99b']},
        {value: "transactional", name: "Транзакционный", availableOperators: ['']},
        //{value: "templated_add", name: "Рекламный с шаблоном", availableOperators: ['570e2be8b52438c11a38f99b']}
      ],
      rulesListVisible: false
    }
  }
}

</script>
